import React, { useEffect } from "react";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";
import { useRouter } from "next/navigation";
import styles from "@/components/modal/license-limited-modals/styles/license-limited-modal.module.scss";
import GetFreeAccessButton from "@/components/common/get-free-access-button";
import IncreaseLimitsButton from "@/components/common/increase-limits-button";
import { LicenseName } from "@/data/license.data";

export interface LicenseLimitedModalPropsBase {
  licenseName: LicenseName;
}

interface LicenseLimitedModalProps extends LicenseLimitedModalPropsBase {
  shouldNavigateToPricing?: boolean;
}

const SubscriptionExpiredModal = ({
  shouldNavigateToPricing,
  licenseName,
}: LicenseLimitedModalProps) => {
  const { hideModal } = useGlobalModalContext();
  const router = useRouter();

  useEffect(() => {
    if (shouldNavigateToPricing) {
      router.push("/pricing");
    }
  }, [router, shouldNavigateToPricing]);

  return (
    <div className={styles.trial_modal}>
      <div className={styles.main_text}>
        Thank you for using <br /> {licenseName.toLowerCase()} version of
        AudioModify!
      </div>
      <div className={styles.sub_container}>
        <div>
          Your subscription for the {licenseName.toLowerCase()} version has
          expired!
        </div>
      </div>

      <div className={styles.please_upgrade}>
        Please upgrade to the paid version to get unlimited features and more!
        <br />
        30% off only today with discount code &quot;cover&quot;
        <br />
      </div>
      <GetFreeAccessButton />
      <IncreaseLimitsButton filled={true} onClick={hideModal} />
    </div>
  );
};

export default SubscriptionExpiredModal;
